
import axios from '@/plugins/api.request'

/**
 * 列表
 * @param {*} params
 */
 export const scratchWorkList = (params) => {
  return axios.request({
    method: 'get',
    url: 'edu.project/workListByScrach',
    params
  })
}

/**
 * 发布
 * @data {*} data
 */
 export const publishScratchWork = (data) => {
  return axios.request({
    method: 'post',
    url: 'project.scratch/publish',
    data
  })
}